import 'babel-polyfill';
import serialize from 'form-serialize';
import { ajax } from './functions/ajax';

function getURLParameter(name, source) {
    return decodeURIComponent((new RegExp('[?|&amp;|#]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(source) || [, ''])[1].replace(/\+/g, '%20')) || null;
}

const accessToken = getURLParameter('access_token', location.hash);

if (typeof accessToken === 'string' && accessToken.match(/^Atza/)) {
    document.cookie = `amazon_Login_accessToken=${accessToken};path=/;secure`;
}

window.showLoginButton = (merchantId) => {
    OffAmazonPayments.Button('AmazonPayButton', merchantId, {
        type: 'PwA',
        color: 'Gold',
        size: 'medium',
        authorization: () => {
            const loginOptions = { scope: 'payments:widget', popup: false };
            amazon.Login.authorize(loginOptions, 'payment/amazon/success');
        },
    });
}

function triggerCouponCheck(target) {
    if (target && target.value) {
        if (!target.value.trim()) {
            replacePrice();
            target.parentNode.classList.remove('valid');
            target.parentNode.classList.remove('invalid');
            target.parentNode.classList.remove('checking');
        }

        if (target.id == 'coupon' && target.value.trim()) {
            const originalPrice = document.querySelector('.price-information .price');

            if (originalPrice.dataset.originalprice && target.dataset.coupontype) {
                target.parentNode.classList.add('checking');
                checkCoupon(target.value, target, originalPrice.dataset.originalprice, target.dataset.coupontype);
            }
        }
    }
}

function triggerScCouponCheck(couponInput, targetform) {
    if (!couponInput.value.trim()) {
        replacePrice();
        couponInput.parentNode.classList.remove('valid');
        couponInput.parentNode.classList.remove('invalid');
        couponInput.parentNode.classList.remove('checking');
    }

    if (couponInput.id == 'coupon' && couponInput.value.trim()) {
        const priceInfo = document.querySelector(targetform + ' .price-information .price');

        if (priceInfo.dataset.originalPrice) {
            couponInput.parentNode.classList.add('checking');
            checkCoupon(couponInput.value, couponInput, priceInfo.dataset.originalPrice, couponInput.dataset.coupontype);
        }
    }
}

document.addEventListener('focusout', (event) => {
    const { target } = event;

    triggerCouponCheck(target);
    if (target.id == 'coupon') {
        let shortcodeWrapper = target.closest('.by-laravel-shortcode');
        if (shortcodeWrapper) {
            triggerScCouponCheck(target, '#' + shortcodeWrapper.id);
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const couponInput = document.getElementById('coupon');

    if (couponInput) {
        triggerCouponCheck(couponInput)
    }
});

document.addEventListener('DOMContentLoaded', async () => {
    if (!window.stripe) {
        return;
    }

    const style = {
      base: {
        color: '#32325d',
        fontFamily: '"Open Sans",sans serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    };

    createCardElement(style);
    createIbanElement(style);

    const cardholderName = document.getElementById('card_holder');

    window.cartButton = document.getElementById('submitButton');
    if (window.cartButton) {
        window.cartButton.addEventListener('click', async (ev) => {
            const [selectedPaymentMethodRadio] = Array.from(document.getElementsByName('payment_brand')).filter(radio => radio.checked);

            const registerForm = document.getElementById('register-form');

            idleButton(window.cartButton);

            if (!selectedPaymentMethodRadio || selectedPaymentMethodRadio.value === 'paypal') {
                registerForm.submit();
                return;
            }

            ev.preventDefault();

            const formData = serialize(document.getElementById('register-form'), {
                hash: true,
            });

            const creditCardResponse = await validateCreditCardData(selectedPaymentMethodRadio.value, window.cardElement, cardholderName);
            if (creditCardResponse && creditCardResponse.paymentMethodId) {
                formData.payment_method_id = creditCardResponse.paymentMethodId;
            }

            ajax({
                url: window.cartButton.classList.contains('consultation-submit') ? '/consultation/register' : '/register',
                data: formData,
                success: (resp) => {
                    const response = JSON.parse(resp);

                    if (response.redirect_to) {
                        // success
                        reactivateButton(window.cartButton);
                        window.location.replace(response.redirect_to);
                    }

                    handleServerResponse(response);
                },
            });
        });
    }
});

function idleButton(button) {
    button.classList.add('idle');
    button.disabled = true;
}

function reactivateButton(button) {
    button.classList.remove('idle');
    button.disabled = false;
}


function showMissingCardHolderError() {
    const [errorSpan] = document.getElementsByClassName('card-colder-empty');
    errorSpan.classList.remove('versteckt');

    // Add has-error class to parent input div
    errorSpan.parentNode.classList.add('has-error');
}

function validateCreditCardData(paymentMethod, cardElement, cardholderName) {
    return new Promise((resolve) => {
        if (paymentMethod == 'credit_card') {
            window.stripe.createPaymentMethod('card', cardElement, {
                billing_details: {
                    name: cardholderName.value,
                },
            }).then((result) => {
                if (result.error) {
                    reactivateButton(window.cartButton);

                    if (result.error.code === 'parameter_invalid_empty' && result.error.param === 'billing_details[name]') {
                        showMissingCardHolderError();
                    }
                    resolve();
                } else {
                    resolve({ paymentMethodId: result.paymentMethod.id });
                }
            });
        } else {
            resolve();
        }
    });
}

function handleServerResponse(response) {
    if (response.validationErrors) {
        reactivateButton(window.cartButton);
        return handleValidationErrors(response.validationErrors);
    }

    if (response.error) {
        reactivateButton(window.cartButton);
        return;
    }

    if (response.requires_confirmation) {
        handleCreditCardConfirmation(response);
    }

    if (response.requires_action) {
        switch (response.payment_method) {
            case 'credit_card':
                handleCreditCardAction(response);
                break;

            case 'klarna':
                handleKlarnaAction(response);
                break;

            case 'sepa_debit':
                handleSepaAction(response);
                break;

            default:
                break;
        }

        return;
    }
}

function handleCreditCardConfirmation(response) {
    window.stripe.confirmCardPayment(response.payment_intent_client_secret, {
        payment_method: {
            card: window.cardElement,
            billing_details: {
                name: response.card_holder,
            },
        },
    }).then(function(result) {
        if (result.error) {
            reactivateButton(window.cartButton);
            handleValidationErrors({
                payment_brand: result.error.message,
            });
            return;
        }

        const formData = serialize(document.getElementById('register-form'), {
            hash: true,
        });

        formData.payment_intent_id = result.paymentIntent.id;

        // The card action has been handled - The PaymentIntent
        // can be confirmed again on the server.
        ajax({
            url: window.cartButton.classList.contains('consultation-submit') ? '/consultation/register' : '/register',
            data: formData,
            success: (resp) => {
                const response = JSON.parse(resp);

                if (response.redirect_to) {
                    // success
                   reactivateButton(window.cartButton);
                   window.location.replace(response.redirect_to);
                }

                handleServerResponse(response);
            },
        });
    }).catch((error) => {
        window.location.replace(response.redirect_on_failure || '/payment/cancelled');
    });
}

function handleCreditCardAction(response) {
    // Use Stripe.js to handle required card action
    window.stripe.handleCardAction(response.payment_intent_client_secret)
        .then((result) => {
            if (result.error) {
                reactivateButton(window.cartButton);
                handleValidationErrors({
                    payment_brand: result.error.message,
                });
                return;
            }

            const formData = serialize(document.getElementById('register-form'), {
                hash: true,
            });

            formData.payment_intent_id = result.paymentIntent.id;

            // The card action has been handled - The PaymentIntent
            // can be confirmed again on the server.
            ajax({
                url: window.cartButton.classList.contains('consultation-submit') ? '/consultation/register' : '/register',
                data: formData,
                success: (resp) => {
                    handleServerResponse(JSON.parse(resp));
                },
            });
        }).catch((error) => {
            window.location.replace(response.redirect_on_failure || '/payment/cancelled');
        });

    // success
    reactivateButton(window.cartButton);
    window.location.replace(response.redirect_to);
}

const handleKlarnaAction = async (response) => {
    if (response.public_key && response.client_secret) {
        const stripe = Stripe(response.public_key);

        const { error } = await stripe.confirmKlarnaPayment(
            response.client_secret,
            {
                payment_method: {
                    billing_details: {
                        email: response.email,
                        address: {
                            country: 'DE',
                        },
                    },
                },
                return_url: response.return_url,
            },
        );
    }
};

const handleSepaAction = async (response) => {
    if (response.public_key && response.client_secret) {
        const result = await window.stripe.confirmSepaDebitPayment(
            response.client_secret,
            {
                payment_method: {
                    sepa_debit: window.ibanElement,
                    billing_details: {
                      name: response.account_holder,
                      email: response.email,
                    },
                },
            },
        ).then(function (result) {
            if (result.error) {
                reactivateButton(window.cartButton);
                handleValidationErrors({
                    payment_brand: result.error.message,
                });
                return;
            }

            const formData = serialize(document.getElementById('register-form'), {
                hash: true,
            });

            formData.payment_intent_id = result.paymentIntent.id;

            // The card action has been handled - The PaymentIntent
            // can be confirmed again on the server.
            ajax({
                url: window.cartButton.classList.contains('consultation-submit') ? '/consultation/register' : '/register',
                data: formData,
                success: (resp) => {
                    const response = JSON.parse(resp);

                    if (response.redirect_to) {
                        // success
                       reactivateButton(window.cartButton);
                       window.location.replace(response.redirect_to);
                    }

                    handleServerResponse(response);
                },
            });
        });
    }
};


function handleValidationErrors(errors) {
    Object.entries(errors).forEach(([key, values]) => {
        const node = document.createElement('span');
        node.classList.add('help-block');

        values.forEach((content) => {
            const textSpan = document.createElement('strong');
            textSpan.innerHTML = content;

            node.appendChild(textSpan);
        });

        const [inputWithError] = document.getElementsByName(key);
        const parent = inputWithError.parentNode;
        parent.classList.add('has-error');

        parent.appendChild(node);
    });

    const firstError = document.querySelector('#register-form .has-error');
    if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth' });
    }
}

function createCardElement(style) {
    const cardElementContainer = document.querySelector('#card-element');
    if (cardElementContainer) {
        const elements = window.stripe.elements();
        window.cardElement = elements.create('card', {
            style,
        });

        window.cardElement.mount('#card-element');
    }
}

function createIbanElement(style) {
    const ibanElementContainer = document.querySelector('#iban-element');
    if (ibanElementContainer) {
        const elements = window.stripe.elements();
        window.ibanElement = elements.create('iban', {
            style,
            supportedCountries: ['SEPA'],
            placeholderCountry: 'DE',
        });

        window.ibanElement.mount('#iban-element');

        // add sepa error handling
        window.ibanElement.on('change', (event) => {
            const displayError = document.querySelector('#iban-help-block strong');
            const ibanInputWrapper = document.querySelector('.iban-input-wrapper');
            if (event.error) {
                ibanInputWrapper.classList.add('has-error');
                window.cartButton.disabled = true;
                displayError.textContent = event.error.message;
            } else {
                ibanInputWrapper.classList.remove('has-error');
                reactivateButton(window.cartButton);
                displayError.textContent = '';
            }
        });
    }
}

function checkCoupon(couponCode, input, originalPrice, couponType) {
    ajax({
        url: window.checkCouponURL,
        data: {
            coupon: couponCode,
            originalPrice: originalPrice,
            couponType: couponType,
        },
        success: (response) => {
            const parsedResponse = JSON.parse(response);

            input.parentNode.classList.remove('valid');
            input.parentNode.classList.remove('invalid');
            input.parentNode.classList.remove('checking');

            if (parsedResponse.valid) {
                replacePrice(parsedResponse.price);
                input.parentNode.classList.add('valid');
            }

            if (!parsedResponse.valid) {
                replacePrice(originalPrice);
                input.parentNode.classList.add('invalid');
            }
        },
        error: (errors) => {
            console.log(errors);
        },
    });
}

function replacePrice(newPrice = null) {
    const node = document.querySelector('.price-information .price');
    const price = newPrice !== null ? newPrice : node.dataset.originalPrice;

    node.innerHTML = `einmalig ${Number(price).format()} €`;
}

document.addEventListener('DOMContentLoaded', event => {
    let scPackageLinks = document.querySelectorAll('.sc-package-link');
    scPackageLinks.forEach(function(element) {
        element.addEventListener("click", event => {
            let targetselect = document.querySelector(event.target.dataset.targetform + ' #registration-consultationpackage-select');
            if (targetselect) {
                targetselect.value = event.target.dataset.packageid;
            }

            setPriceInfo(event.target.dataset.targetform, event.target.dataset.price);

            const couponInput = document.querySelector(event.target.dataset.targetform + ' #coupon');
            if (couponInput) {
                triggerScCouponCheck(couponInput, event.target.dataset.targetform);
            }
        });
    });
    let scConsultationPackageSelects = document.querySelectorAll('.registration-consultationpackage-select');
    scConsultationPackageSelects.forEach(element => {
        element.addEventListener('change', event => {
            setPriceInfo('#' + event.target.closest('.by-laravel-shortcode').id, event.target[event.target.selectedIndex].dataset.price);

            const couponInput = document.querySelector('#' + event.target.closest('.by-laravel-shortcode').id + ' #coupon');
            if (couponInput) {
                triggerScCouponCheck(couponInput, '#' + event.target.closest('.by-laravel-shortcode').id);
            }
        });
    });

    var packageLinks = document.querySelectorAll('.package-link');

    packageLinks.forEach(function(element) {
        element.addEventListener("click", event => {
            const couponInput = document.getElementById('coupon');
            document.getElementById('registration-consultationpackage').value = event.target.id;

            changePriceInformation(event.target.id);

            if (couponInput) {
                triggerCouponCheck(couponInput)
            }
        });
    });

    const consultationPackage = document.getElementById('registration-consultationpackage');
    if (consultationPackage) {
        consultationPackage.addEventListener('change', event => {
            const target = event.target;

            changePriceInformation(target.value);

            const couponField = document.getElementById('coupon');

            if (couponField.value) {
                if (!couponField.value.trim()) {
                    replacePrice();
                    couponField.parentNode.classList.remove('valid');
                    couponField.parentNode.classList.remove('invalid');
                    couponField.parentNode.classList.remove('checking');
                }

                if (couponField.id == 'coupon' && couponField.value.trim()) {
                    couponField.parentNode.classList.add('checking');

                    const originalPrice = document.querySelector('.price-information .price');

                    checkCoupon(couponField.value, couponField, originalPrice.dataset.originalprice, 'consultation');
                }
            }
        });
    }
});

function setPriceInfo(targetform, price) {
    let priceInfo = document.querySelector(targetform + ' .price-information .price');
    priceInfo.innerHTML = `einmalig ${Number(price).format()} €`;
    priceInfo.dataset.originalPrice = price;
}

function changePriceInformation(packageType) {
    var originalPrice = document.querySelector('.price-information .price');
    const basic = window.basicprice;
    const top = window.topprice;
    const premium = window.premiumprice;

    if (packageType == 'basic') {
        originalPrice.innerHTML = `einmalig ${Number(basic).format()} €`;
        originalPrice.dataset.originalprice = basic;
    }
    if (packageType == 'top') {
        originalPrice.innerHTML = `einmalig ${Number(top).format()} €`;
        originalPrice.dataset.originalprice = top;
    }
    if (packageType == 'premium') {
        originalPrice.innerHTML = `einmalig ${Number(premium).format()} €`;
        originalPrice.dataset.originalprice = premium;
    }
}
